<button
  class="button icon-button"
  #menuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="menu"
  [class.open]="menuTrigger.menuOpen"
  [matBadge]="unreadCount$ | async"
>
  <app-icon name="ic_bell" />
</button>
<mat-menu #menu="matMenu" xPosition="before" class="notification-menu">
  <div class="item flex justify-between">
    <h3>{{ "notification.headline" | translate }}</h3>
    <a
      class="button icon-button"
      [routerLink]="['/', RouteConstants.routeNotifications]"
    >
      {{ "notification.showAll" | translate }}
      <app-icon name="ic_chevron_right" />
    </a>
  </div>
  <div class="item flex column align-stretch scroll-wrapper">
    @for (notification of notificationList$ | async; track notification.id) {
      <app-notification-card
        [notification]="notification"
        (markAsRead)="onMarkAsRead($event)"
      />
    } @empty {
      {{ "notification.empty" | translate }}
    }
  </div>
</mat-menu>
